import script from "./TachoMonitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./TachoMonitoring.vue?vue&type=script&setup=true&lang=js"

import "./TachoMonitoring.vue?vue&type=style&index=0&id=081ccbdc&scoped=true&lang=css"
import "./TachoMonitoring.vue?vue&type=style&index=1&id=081ccbdc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081ccbdc"]])

export default __exports__